import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import TapAndPlay from '@mui/icons-material/TapAndPlay';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import Download from '@mui/icons-material/Download';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import Medication from '@mui/icons-material/Medication';

const items = [
  {
    icon: <Download />,
    title: 'Stiahnutie aplikácie priamo vo forme APK súboru do Vášho Android zariadenia',
    description:
      '<span style="color: lightblack;">Pre stiahnutie aplikácie kliknite <a href="/images/finalna_app.apk" style="color: white;" download>TU</a>.</span>',
    
  },    
  {
    icon: <TapAndPlay />,
    title: 'Využívanie aplikácie na mobilnom zariadení bez sťahovania', 
    description:
      '<span style="color: lightblack;">Pre otvorenie aplikácie kliknite <a href="https://mobile.uad.lf.upjs.sk" target="_blank" style="color: white;" rel="noopener noreferrer">TU</a>.',
  },
  {
    icon: <Medication />,
    title: 'Rozhranie určené pre lekárov',
    description:
      '<span style="color: lightblack;">Pre otvorenie aplikácie kliknite <a href="https://doktor.uad.lf.upjs.sk" style="color: white;" target="_blank" rel="noopener noreferrer">TU</a>.',
  },
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
        bgcolor: 'hsl(220, 30%, 2%)',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography component="h2" variant="h4">
           Používanie aplikácie
          </Typography>
          <Typography variant="body1" sx={{ color: 'grey.400' }}>
            Pre samotné využívanie systému UAD Monitor je potrebné pokračovať výberom z nasledovných možnosti:
          </Typography>
        </Box>
        <Grid container spacing={2.5}>
          {items.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: 'inherit',
                  p: 3,
                  height: '100%',
                  border: '1px solid',
                  borderColor: 'hsla(220, 25%, 25%, .3)',
                  background: 'transparent',
                  backgroundColor: 'grey.900',
                  boxShadow: 'none',
                }}
              >
                <Box sx={{ opacity: '50%' }}>{item.icon}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: 'grey.400' }}
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
